import { all, fork } from "redux-saga/effects";
//public
import accountSaga from "./auth/register/saga";
import AuthSaga from "./auth/login/saga";
import ForgetSaga from "./auth/forgetpwd/saga";
import userlist from "./users/saga";
import clientlist from "./clients/saga";
import ManageSites from "./sites/saga";
import sitelist from "./manageSite/saga";
import ProfileSaga from "./auth/profile/saga";
import ManageUserSaga from './manageUser/saga'
// import userlist from "./users/saga"

export default function* rootSaga() {
  yield all([
    //public
    fork(accountSaga),
    fork(AuthSaga),
    fork(ForgetSaga),
    fork(userlist),
    fork(clientlist),
    fork(sitelist),
    fork(ManageSites),
    fork(ProfileSaga),
    fork(ManageUserSaga)
  ]);
}
